module.exports = __webpack_public_path__ + "assets/img/INTERIOR3.c7923fc0.png";